import * as React from "react";
import * as ReactDOM from "react-dom/client";
import AppLocal from "./AppLocal";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<AppLocal />);
